import { DesignChannel } from 'components/NewFileModal/Types'

export const isSinglePageChannel = (channel: DesignChannel) => {
  return [DesignChannel.InstagramReel, DesignChannel.TikTokPost, DesignChannel.YoutubeShort].includes(channel)
}
